import { useCallback, useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { useListingLoader } from "../../../../components/hooks/ListingHooks";
import SelectionDeleter from "../../../../components/TableComponents/SelectionDeleter";
import ItemDeleter from "../../../../components/TableComponents/ItemDeleter";
import { Group } from "@mantine/core";
import dateColumn from "../../../../layouts/Table/columns/dateColumn";
import { nameColumn } from "../../../../layouts/Table/columns/nameColumn";
import MainTable from "../../../../layouts/Table/MainTable";
import TableLayoutBlock from "../../../../layouts/Table/TableLayoutBlock";
import { deleteTag, editTag, getTags } from "../../../../api/TagsAPI";
import { sharingColumn } from "../../../../layouts/Table/columns/sharingColumn";
import PageTitle from "../../../../components/View/PageTitle";
import SelectionSharer from "../../../../components/TableComponents/SelectionSharer";

const TagsListing = () => {
  const apiRef = useGridApiRef();
  const lang = useLanguage((s) => s.language);

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const columns = useMemo(
    () => [
      nameColumn({
        parentPath: () => `/extra/tags`,
        disableLink: true,
        editFunction: () => editTag,
        getDisabled: () => false,
        apiRef,
      }),
      dateColumn(),
      sharingColumn({ apiRef, editFunction: () => editTag }),
    ],
    [apiRef]
  );

  const actionsCell = useCallback(
    ({ row }) => {
      return (
        <ItemDeleter
          title_bold={`${row.name} #${row.id}`}
          handleDelete={deleteTag}
          deletedMessage={lang.tags.delete_success}
          id={row.id}
          apiRef={apiRef}
        />
      );
    },
    [apiRef, lang.tags.delete_success]
  );

  const toolbarActions = useCallback(
    ({ selectedIds }) => (
      <>
        <SelectionDeleter
          handleDelete={deleteTag}
          apiRef={apiRef}
          setTableLoading={setLoading}
          ids={selectedIds}
        />

        <SelectionSharer
          handleShare={editTag}
          apiRef={apiRef}
          setTableLoading={setLoading}
          ids={selectedIds}
        />
      </>
    ),
    [apiRef]
  );

  useListingLoader({
    loading,
    setLoading,
    listGetter: getTags,
    responseField: "tags_list",
    setRows,
  });

  return (
    <>
      <Group
        className="layout-block top"
        w={"100%"}
        gap={0}
        justify="space-between"
      >
        <PageTitle title={lang.tags.browser_tab_title} />
      </Group>

      <TableLayoutBlock>
        <MainTable
          apiRef={apiRef}
          columns={columns}
          rows={rows}
          loading={loading}
          setLoading={setLoading}
          id={"list-table"}
          toolbarActions={toolbarActions}
          actionsCell={actionsCell}
          actionsCellWidth={50}
        />
      </TableLayoutBlock>
    </>
  );
};

export default TagsListing;
